import React from "react";
import "./AutomationHero.css";

export default function AutomationHero() {
  return (
    <div id="automation-hero" className="outsourcemainclass">
      <div className="left">
        <h1>IT Outsourcing Services</h1>
        <p>
          We help businesses design, migrate, and optimize cloud environments
          with secure, scalable strategies that drive agility, innovation, and
          faster time-to-value across the enterprise.
        </p>
      </div>
    </div>
  );
}
